import groupModule from '../groupModule';

function groupStore(groupResources) {
    "ngInject";
    return {
        restrict: "A",
        templateUrl: groupResources.templates.groupStoreTemplate,
    }
};

groupModule.directive("groupStore", groupStore);

export default groupStore;